import * as Yup from 'yup';
import styled, { css } from 'styled-components';
import { Property } from 'csstype';

import Button from '@components/Button/next';
import { ContactType } from '@api/index';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 16px;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0;
  }
`;

export const InfoWarning = styled.div`
  margin: 10px 0px 10px 0px;
  display: flex;
  padding: 12px 10px;
  background-color: ${({ theme }) => theme.palette.lightRed};
  border-radius: 8px;
  color: ${({ theme }) => theme.palette.R600};
  font-size: 16px;
  font-weight: 600;
  gap: 6px;
  align-items: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin: 10px 16px 10px 16px;
  }
`;

export const infoTextMixin = css`
  font-size: 16px;
  font-weight: normal;
  line-height: 1.5;
  color: ${({ theme }) => theme.palette.matterHorn};
`;

export const InfoText = styled.p`
  ${infoTextMixin}
  padding: 0;
  margin: 0;
  white-space: pre-wrap;
`;

export const InfoBoldText = styled.span`
  ${infoTextMixin}
  font-weight: bold;
`;

export const RequiredWarningText = styled.div`
  opacity: 0.75;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${({ theme }) => theme.palette.matterHorn};
`;

export const SubHeader = styled.div``;

export const NameCol = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    grid-template-columns: 1fr;
    grid-row-gap: 20px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ApplyButton = styled(Button)`
  && {
    max-width: 220px;
    @media ${({ theme }) => `(max-width: ${theme.breakPoint.SMALL})`} {
      max-width: 290px;
    }
    height: 58px;
    font-weight: bold;
    font-size: 16px;
  }
`;

export const StyledRow = styled.div<{
  alignItems?: Property.AlignItems;
  justifyContent?: Property.JustifyContent;
}>`
  display: flex;
  flex-direction: row;
  ${({ alignItems }) =>
    alignItems &&
    css`
      align-items: ${alignItems};
    `};
  ${({ justifyContent }) =>
    justifyContent &&
    css`
      justify-content: ${justifyContent};
    `};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.SMALL})`} {
    width: 290px;
  }
`;
export const KvkkInfoUnderlined = styled.span`
  font-size: 14px;
  height: auto;
  font-weight: bold;
  text-decoration: underline;
  height: 20px;
  margin-bottom: 10px;
  word-break: break-word;
  white-space: pre-wrap;
`;

export const StyledAvailableTime = styled.div`
  & span {
    white-space: nowrap;
  }
`;

export const ApplyButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  box-shadow: 0px -10px 20px 0px rgba(58, 58, 58, 0.1);
  padding: 16px;

  && button {
    width: 100%;
    max-width: 100%;
  }

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0;
    box-shadow: unset;

    && button {
      width: 100%;
      max-width: 220px;
    }
  }
`;

export const AvailableTimeData: { value: string; label: string }[] = [
  {
    value: '101',
    label: '9:00 - 12:00',
  },
  {
    value: '111',
    label: '12:00 - 15:00',
  },
  {
    value: '121',
    label: '15:00 - 18:00',
  },
  {
    value: '131',
    label: '18:00 - 24:00',
  },
];
export const schema = Yup.object().shape({
  firstName: Yup.string().required('Zorunlu Alan'),
  lastName: Yup.string().required('Zorunlu Alan'),
  contactOption: Yup.string()
    .oneOf([ContactType.PHONE])
    .required('Zorunlu Alan'),
  phone: Yup.string().when('contactOption', {
    is: (val: string) => val === ContactType.PHONE,
    then: Yup.string().required(
      'Lütfen geçerli bir telefonu numarası giriniz.'
    ),
  }),

  availableTime: Yup.string().oneOf(
    AvailableTimeData.map(({ value }) => value)
  ),
  message: Yup.string(),
});
